// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-button-helper{cursor:default !important;background-color:#dcdee3 !important;color:#76797f !important}`, "",{"version":3,"sources":["webpack://./src/components/DisabledButtonHelper/index.scss"],"names":[],"mappings":"AAAA,wBACE,yBAAA,CACA,mCAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
